const BlogApi = [
  {
    id: 1,
    image: "./images/cert.jpeg",
    date: "20th January, 2024",
    title_one: "Earning My Meta Frontend Certificate: A Journey of Growth",
    desc_one:
      "In this blog post, I share my experience with the Meta Frontend program, which provides a comprehensive curriculum on frontend development. The program covers essential technologies such as HTML, CSS, JavaScript, and React, enabling learners to build dynamic and responsive web applications. Throughout the course, I gained practical skills in UI/UX design, version control with Git, and best coding practices. This certification has significantly enhanced my career, opening new opportunities and allowing me to apply my knowledge in real‑world projects. For those considering this path, I recommend dedicating time to hands‑on projects and collaborating with peers to maximize your learning experience.",
    link: "https://www.coursera.org/account/accomplishments/professional-cert/ESFU4ABASJAZ",
  },
  {
    id: 2,
    image: "./images/blog-01.png",
    date: "June 2025",
    title_one: "AI and Web Development: 2025’s Top Trends",
    desc_one:
      "AI is reshaping web development—from intelligent design assistants to automatic code generation and bug detection. Explore how AI‑driven tools like Copilot and Sensei empower developers, streamline workflows, and enhance UX through personalization and responsive design :contentReference[oaicite:1]{index=1}.",
    link: "https://logicballs.com/blog/ai-trends-in-web-development/",
  },
  {
    id: 3,
    image: "./images/blog-03.png",
    date: "February 2025",
    title_one: "The Future of PWAs: Trends in 2025",
    desc_one:
      "Progressive Web Apps are evolving—offering offline functionality, app‑like experience, and enhanced engagement. This guide covers service workers, caching, and market growth, along with use cases from Pinterest, Starbucks, and Uber :contentReference[oaicite:2]{index=2}.",
    link: "https://www.nucamp.co/blog/coding-bootcamp-full-stack-web-and-mobile-development-2025-progressive-web-apps-pwas-in-2025-the-future-of-web-and-mobile-integration",
  },
  {
    id: 4,
    image: "./images/blog-02.png",
    date: "February 2025",
    title_one: "Optimizing for Voice Search: Web Dev’s Next Frontier",
    desc_one:
      "As voice assistants like Alexa and Siri become mainstream, voice-search optimization is emerging as a key area for developers. Learn how conversational UIs, semantic markup, and accessibility can boost discoverability and UX :contentReference[oaicite:3]{index=3}.",
    link: "https://webplore.com/the-future-of-web-development-trends-to-watch-in-2025/",
  },
];

export default BlogApi;
